import { useLocation } from "react-router";
import Init from "./init";
import Reset from "./reset";

export default function Recovery(){

    const location = useLocation()
    const params = new URLSearchParams(location.search)

    if(params.get('otp_code') && params.get('token')) return <Reset />

    return <Init />
}